export default __webpack_public_path__ + "images/bag_not_available_icon.3d85c5b.png";